import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import React from 'react';

export const LabeledDetail: React.FC<{
  label: string;
  detailFontSize?: string | number;
  detailWidth?: string | number;
  buttons?: React.ReactNode[];
}> = ({ buttons, label, detailFontSize = '20px', detailWidth, children }) => {
  return (
    <Box height="100%">
      <HStack verticalAlign="center">
        <Text
          fontSize="14px"
          color="#979797"
          fontWeight="bold"
          mb="5px"
          mt="5px"
        >
          {label}
        </Text>
        {buttons && <Flex>{buttons.map((button) => button)}</Flex>}
      </HStack>
      <Text fontSize={detailFontSize} w={detailWidth}>
        {children}
      </Text>
    </Box>
  );
};
